import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n/LocalizationProvider';
import type { TranslationContent } from '../i18n/translations';
import { useAuth } from '../auth/AuthContext';

export default function HomePage() {
  const { t } = useTranslation();
  const stats = t<TranslationContent['home']['stats']>('home.stats');
  const actions = t<TranslationContent['home']['actions']>('home.actions');
  const reasons = t<string[]>('home.reasons.items');
  const { session } = useAuth();
  const roleLink = session?.role === 'admin'
    ? '/admin'
    : session?.role === 'user'
      ? '/org'
      : session?.role === 'subuser'
        ? '/subuser'
        : '/login';
  const roleLabel = session ? t(`layout.roles.${session.role}`) : t('layout.nav.login');

  return (
    <div className="panel">
      <div className="section-heading">
        <div>
          <span className="badge">{t('home.badge')}</span>
          <h1>{t('home.title')}</h1>
          <p className="text-muted">{t('home.description')}</p>
        </div>
      </div>

      <div className="hero">
        <div>
          <div className="hero-graphic" aria-hidden />
          <div className="hero-stats">
            <div className="stat">
              <span>{stats.schools.label}</span>
              <strong>{stats.schools.value}</strong>
            </div>
            <div className="stat">
              <span>{stats.programs.label}</span>
              <strong>{stats.programs.value}</strong>
            </div>
            <div className="stat">
              <span>{stats.assessments.label}</span>
              <strong>{stats.assessments.value}</strong>
            </div>
          </div>
        </div>

        <div className="form-grid" style={{ gap: '1.5rem' }}>
          <div className="panel" style={{ boxShadow: 'none', border: '1px dashed var(--color-border)' }}>
            <h3>{actions.title}</h3>
            <p>{actions.description}</p>
            <div className="form-grid">
              <Link to={roleLink} className="link-button">{roleLabel}</Link>
              {!session && (
                <Link to="/login" className="link-button">{actions.links.login}</Link>
              )}
            </div>
          </div>

          <div className="panel" style={{ boxShadow: 'none', border: '1px dashed var(--color-border)' }}>
            <h3>{t('home.reasons.title')}</h3>
            <ul className="text-muted">
              {reasons.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
